import 'whatwg-fetch';
import { api, jsonData } from 'config';
import { ecommerce, consumer, pages } from 'config/constants';
import CMSFactory from "factories/CMS";
import Day from 'dayjs';
import fetchApi from 'services/Promise';
import StorageService from 'services/StorageService';

const apiUrlWp = api.cms;

const getHome = (id = pages.home, cache = 'home', renderData = 'cms') => {
    const transformRenderData = data => {
        return  {
            acf: {
                content: data.content,
                banners: data["home-banner"],
                banner_info:  data['banner_info'],
                warning: data.warning
            },
            datetime: data.datetime
        }
    };

    return fetchApi.getJsonWithCache(`${jsonData.cms}/page-${id}.json`, cache, renderData, transformRenderData).then(results => {
        return results;
    });
}

const getSchool = (id, cache) => {
    return fetchApi.getJsonWithCache(`${jsonData.cms}/page-${id}.json`, cache);
}

const getPage = (node, id) => {
    return fetchApi.getJsonWithCache(`${jsonData.cms}/page-${(node !== 'version') ? id : pages.version}.json`, node, node);
}

const getPostBySlug = (slug, noList = false) => { 
    if (typeof window !== 'undefined' && window.__renderData && window.__renderData[slug]) {
        return new Promise(resolve => {
            const dataLanding = window.__renderData[slug];
            delete window.__renderData[slug];
            resolve(dataLanding);
        });
    }

    return fetchApi.getJsonWithCache(`${jsonData.cms}/${(noList ? `${slug}.json` : `list-${slug}.json`)}`, slug);
}

const getListHelpCenterCategories = () => {
    const renderName = 'helpCenterCat';
    if (typeof window !== 'undefined' && window.__renderData && window.__renderData[renderName] && window.__renderData[renderName].length) {
        return new Promise(resolve => {
            const dataLanding = window.__renderData[renderName];
            delete window.__renderData[renderName];
            resolve(dataLanding);
        });
    }

    return getPostBySlug('help-category', true).then(data => {
        if(data && data[0] && data[0].acf && data[0].acf.order){
            data.sort((a, b) => {
                return parseInt(a.acf.order) > parseInt(b.acf.order) ? 1 : -1;
            });
        }

        return data;
    });
}

const getListHelpCenter = (id) => {
    const renderName = 'helpCenterQuestions';
    if (typeof window !== 'undefined' && window.__renderData && window.__renderData[renderName] && window.__renderData[renderName].length) {
        return new Promise(resolve => {
            const dataLanding = window.__renderData[renderName];
            delete window.__renderData[renderName];
            resolve(dataLanding);
        });
    }

    return getPostBySlug('help-center-'+id);
}

const getListNotices = () => {
    return getPostBySlug('notices');
}


const getMenu = (filterFixed = true) => {
    return getPage('menu', pages.menu).then(results=> getMenuFiltred(results, filterFixed));
}

const getMenuFiltred = (results, filterFixed = true) => {
    const fixedCategories = [];

    if(!(results && results.acf && results.acf.items && results.acf.items.length)){
        return {
            acf: {
                items: [],
                fixed_categories: [],
                offers : []
            }
        };
    }

    let data = {...results.acf};

    const categoryFixes = data.fixed_categories.map(fixedCat => fixedCat.title);

    const departments = _selectActive(data.items).map(category => {
        let link = { ...category };

        if (categoryFixes.indexOf(link.title) !== -1) {
            fixedCategories.push(link);

            if(filterFixed){
                return false;
            }
        }

        return link;

    }).filter((i) => i);

    const ordenfixedCategories = [];

    categoryFixes.map((category) => {
        if (fixedCategories.findIndex((val) => val.title === category) !== -1) {
            ordenfixedCategories.push(fixedCategories[fixedCategories.findIndex((val) => val.title === category)]);
        }
        return category;
    });

    data.items = departments;
    data.fixed_categories = ordenfixedCategories;

    return {
        acf: {
            items: data.items,
            fixed_categories: data.fixed_categories,
            offers: data.offers
        }
    }
}

const _selectActive = (list) => {
    return list.filter(obj => {

        if(obj.items){
            obj.items = _selectActive(obj.items);
        }

        return obj.active === true;
    });
}

const getVersion = () => {
    return getPage('version')
}

const getPageTermsConditions = () => {
    return getPage('terms', pages.tyc)
}

const getPageSecurityandPrivacy = () => {
    return getPage('security', pages.securityPrivacy);
}

const getPageFrequentQuestions = () => {
    return getPage('faq', pages.frequentQuestions);
}

const getPageContest = () => {
    return getPage('contest', pages.contest);
}

const getOffers = () => {
    return getPage('offer', pages.offers);
}

const getPageBenefits = () => {
    return getPage('benefits', pages.benefits);
}

const getOperations = () => {
    return getPage('operations', pages.operations).then(results => _getOperationsValue(results));
}
const getOperationsV2 = () => {
    return getPage('operationsV2', pages.operationsV2).then(results => _getOperationsValue(results));
}

const getPageOurServices = () => {
    return getPage('ourServices', pages.ourServices);
}

const getFilesProviders = () => {
    return getPage('providers', pages.providers);
}

const getRegisterFormSchools = () => {
    return getPage('schoolsForm', pages.registerForm);
}
const getCampaingsCMS = () => {
    return getPage('campaignCMS', pages.campaignCMS);
}

const getCommitmentsJumboCMS = () => {
    return getPage('commitmentsJumbo', pages.commitmentsJumbo);
}

const getNewCommitmentsJumboCMS = () => {
    return getPage('newCommitmentsJumbo', pages.newCommitmentsJumbo);
}

const _getOperationsValue = (data) => {
    if(!(data && data.acf)){
        return data;
    }

    let results = {...data.acf};

    if(!(results.store && results.states)){
        return results;
    }
    if (results.car) {
        results.car = results.car.map(item => {
            if (!item.active) return false;
            return {
                label: item.name,
                sc: item.sc,
                value: item.value
            }
        }).filter(Boolean);
    }

    results.store = results.store.map(item => {
        if(!item.active) return false;

        let response = {
            name: item.name,
            label: item.name,
            sc: item.sc,
            value: item.value,
            active: item.active,
            auto: item.auto,
            store: item.store,
            address: item.address,
        }

        if(ecommerce.whiteLabel){
            if(!item.seller) return false;
            response['seller'] = _getStoreSeller(item.seller);
            response['warehouse_id'] = item.warehouse_id;
            response['coordinates'] = item.coordinates;
            response['sc_virtual'] = item.sc_virtual;
        }

        return response
    }).filter(Boolean);

    results.states = results.states.map(item => {
        if(!item.active) return false;
        return {
            label: item.name,
            name: item.name,
            cities: item.cities,
            value: item.value
        }
    }).filter(Boolean);

    return results;
}

const validSCItem = (validation = null) => {

    try{
        let  sc = StorageService.getSecureItem('sales_channel');
        sc = sc ? parseInt(sc) : null;
        const salesChannels = (validation && validation.sc) ? validation.sc.trim().split(',') : null;

        if(sc){
            if((validation && validation.type == 'include') && (salesChannels && salesChannels.length && (salesChannels.findIndex(item => parseInt(item) === sc) === -1))){
                return false;
            }
            if((validation && validation.type == 'exclude') && (salesChannels && salesChannels.length && (salesChannels.findIndex(item => parseInt(item) === sc) !== -1))){
                return false;
            }
        }else{
            if(validation && (validation.type == 'include') && (salesChannels && salesChannels.length)){
                return false;
            }
        }

        return true
    }catch(e){
        /* eslint-disable no-console */
        console.log(e);
        /* eslint-enable no-console */
        return false
    }
}

const validDatesItem = (item, serverDate) => {

    let startDate = item.start_date ? CMSFactory.milliseconds(item.start_date) : '';
    let endDate = item.end_date ? CMSFactory.milliseconds(item.end_date) : '';
    if (startDate && (startDate >= serverDate)) return false;
    if (endDate && (endDate <= serverDate)) return false;

    return true;
}

const _getStoreSeller = (seller) => {
    return consumer.replace('santaisabel', '') + seller;
};

const validSellerItem = (validation = null) => {
    try{
        let  seller = StorageService.getItem('seller');
        seller = seller ? seller : null;
        const sellers = (validation && validation.seller) ? validation.seller.trim().split(',') : null;

        if(seller){
            if((validation && validation.type == 'include') && (sellers && sellers.length && (sellers.findIndex(item => item === seller) === -1))){
                return false;
            }
            if((validation && validation.type == 'exclude') && (sellers && sellers.length && (sellers.findIndex(item => item === seller) !== -1))){
                return false;
            }
        }else{
            if(validation && (validation.type == 'include') && (sellers && sellers.length)){
                return false;
            }
        }

        return true
    }catch(e){
        /* eslint-disable no-console */
        console.log(e);
        /* eslint-enable no-console */
        return false
    }
}

const _getPostType = (path = '', type = 'category', renderName = null, retry = true) => {
    const url = `${jsonData.cms}/${path}.json`;
    renderName = renderName || type;

    if (typeof window !== 'undefined' && window.__renderData && window.__renderData[renderName] && window.__renderData[renderName].length) {
        return new Promise(resolve => {
            const dataLanding = window.__renderData[renderName].filter(res => res.slug === path);
            delete window.__renderData[renderName];
            resolve(dataLanding);
        });
    }

    if(!retry) return fetchApi.getJson(url);

    return fetchApi.retry(() => fetchApi.getJson(url));
}

const getPostType = (slug, type) => {
    return _getPostType(slug, type);
}

const getLanding = (path = '') => {
    return _getPostType(path, 'offers', 'landing');
}

let cachePromise = {
    path: null,
    promise: null
};

const getPLP = (path = '', type = 'category') => {

    if(path === '') return Promise.resolve([]);

    if(cachePromise.path === path && cachePromise.promise) return cachePromise.promise;
    cachePromise.path = path;
    cachePromise.promise = _getListBanner(path, type).then(category => {
        if(!category) return [];
        return _getPostType(path, type, null, false).then((response) => {
            cachePromise.promise = null;
            cachePromise.path = null;
            return response;
        });
    })

    return cachePromise.promise;
}

const _getListBanner = (path, type) => {
    return fetchApi.getJsonWithCache(`${jsonData.cms}/list-${type}.json`, 'list-' + type).then(data => {
        return data.indexOf(path) !== -1;
    });
}

let _datetime = null;

const getDateTime = () => {
    if (_datetime) {
        return Promise.resolve(_datetime);
    }

    return fetchApi.retry(() => fetchApi.get(apiUrlWp + `/cms/datetime`))
        .then(results => {
            if (!results || (results.status && results.message)) {
                return false;
            }
            return results;
        })
        .then(result => {
            if (!result) return false;

            const dateTime = Day(result.datetime).format();
            _datetime = { datetime: dateTime };
            return _datetime;
        }).catch(() => {
            _datetime = null;
            return false;
        });
}

let cachePromiseDate = null

const getDateTimeCache = () => {
    if (cachePromiseDate) {
        return cachePromiseDate;
    }

    cachePromiseDate = fetchApi.retry(() => fetchApi.get(apiUrlWp + `/cms/datetime`))
        .then(results => {
            if (!results || (results.status && results.message)) {
                return false;
            }
            return results;
        })
        .then(result => {
            if (!result) return false;

            const dateTime = Day(result.datetime).format();
            _datetime = { datetime: dateTime };
            cachePromiseDate = null
            return _datetime;
        }).catch(() => {
            _datetime = null;
            cachePromiseDate = null
            return false;
        });

    return cachePromiseDate
}

const CmsService = {
    getHome,
    getSchool,
    getPage,
    getMenu,
    getVersion,
    getPageTermsConditions,
    getPageSecurityandPrivacy,
    getPageFrequentQuestions,
    getPageContest,
    getOffers,
    getPageBenefits,
    getOperations,
    getPageOurServices,
    getFilesProviders,
    getRegisterFormSchools,
    getPostType,
    getLanding,
    getPLP,
    getDateTime,
    validSCItem,
    getOperationsV2,
    validDatesItem,
    getListHelpCenterCategories,
    getListHelpCenter,
    getPostBySlug,
    getListNotices,
    getMenuFiltred,
    getCampaingsCMS,
    validSellerItem,
    getCommitmentsJumboCMS,
    getDateTimeCache,
    getNewCommitmentsJumboCMS
}

export default CmsService;
